export default __webpack_public_path__ + "static/subset-UniNeueBook-Italic-9f4f073f97feb17c993da7efa87ac16e.woff";